// Mirrors AccountUser::AVAILABLE_PERMISSIONS on the backend
export const AVAILABLE_PERMISSIONS = [
  'conversations_all',
  'conversations_search_all',
  'blocklist_manage',
  'canned_shared_manage',
  'inboxes_manage',
  'bot_rate',
]
